import { Opportunity } from '../../../graphql-generate/graphql-types';
import rawOpportunities from '../rawData/opportunities.json';

const opportunities: Opportunity[] = [...rawOpportunities];

export default opportunities;
